import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  PortNumberBlockDetails,
} from '../../port-phonenumber.model';
import {MessageService} from 'primeng/api';
import {I18NextService} from 'angular-i18next';
import {FormEmitter} from "../../../forms/form.component";

@Component({
    selector: 'app-phonenumber-port-one-number',
    templateUrl: './phonenumber-port-one-number.component.html',
    standalone: false
})
export class PhonenumberPortOneNumberComponent {

  @Output() public readonly selected = new EventEmitter<PortNumberBlockDetails[]>();
  @Output() public readonly onBack = new EventEmitter();

  @Input() trunkPrefix: string;
  @Input() countryCode: string;

  public isFormValid = false;
  private formValues: PortNumberBlockDetails;


  constructor(public messageService: MessageService,
              public i18next: I18NextService) {
  }

  public back() {
    this.onBack.emit();
  }

  public next() {
    this.selected.emit([this.formValues]);
  }

  onFormChanged(form: FormEmitter<PortNumberBlockDetails>) {
    this.isFormValid = form.formGroup.valid;
    if (form.formGroup.valid) {
      this.formValues = form.data;
    }
  }

}
